'use client';

import Avatar from '@ui/Avatar';
import Button from '@ui/Button';
import Card from '@ui/Card';
import Link from '@ui/Link';
import Typography from '@ui/Typography';
import React, { Suspense, use, useState } from 'react';
import UserConnectionsDialog from './home-page-dialogs/UserConnectionsDialog';
import SmallCardedSkeleton from './SmallCardedSkeleton';
import { cx } from 'cva';
import AppLink from '../next-ui/Link/Link';
import Image from 'next/image';
import { getJobTitle } from '@/utils/user.helper';

function UserConnections(props) {
  const { userConnectionsPromise, className, home } = props;
  const { connections, hasMore } = use(userConnectionsPromise);

  const [showAll, setShowAll] = useState(false);

  if (!connections || !connections.length) {
    return null;
  }

  if (home) {
    return (
      <>
        <Image
          width={40}
          height={40}
          src="/assets/icons/my-communities.svg"
          alt="my community"
          className="h-10 w-10"
        />
        <Typography
          variant="h3"
          className="cursor-pointer text-left hover:text-text-hyperlink"
          onClick={() => setShowAll(true)}>
          Connections
        </Typography>
        {showAll && (
          <UserConnectionsDialog
            open={showAll}
            title="My Connections"
            onClose={() => setShowAll(false)}
          />
        )}
      </>
    );
  }

  return (
    <Suspense fallback={<SmallCardedSkeleton title="Connections" />}>
      <Card className={cx('gap-6', className)} variant="flat" padding="none">
        <div className="grid w-full grid-cols-3">
          <div className={cx(hasMore ? 'col-span-2' : 'col-span-3')}>
            <Typography variant="h3">Connections</Typography>
          </div>
          {hasMore && (
            <button
              type="button"
              className="text-12 text-text-hyperlink"
              onClick={() => setShowAll(true)}>
              View All
            </button>
          )}
        </div>
        <div className="flex flex-col gap-6">
          {connections.map((profile) => (
            <div
              className="flex items-center gap-4"
              key={`${profile.type}-${profile.id}`}>
              <Avatar
                src={profile.avatar}
                alt={profile.name}
                profile={profile.type}
              />
              <AppLink
                href={
                  profile.type === 'npo'
                    ? `/nonprofit/${profile.slug}`
                    : `/${profile.slug}`
                }>
                <Typography
                  variant="subtitle1"
                  className="group-hover:text-text-hyperlink">
                  {getJobTitle(profile)}
                </Typography>
              </AppLink>
            </div>
          ))}
        </div>

        {showAll && (
          <UserConnectionsDialog
            open={showAll}
            title="My Connections"
            onClose={() => setShowAll(false)}
          />
        )}
      </Card>
    </Suspense>
  );
}

export default UserConnections;
